import React from 'react';

export const ModalDialogDone: React.FC = () => (
	<svg width='8rem' height='8rem' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='40' cy='40' r='38' stroke='#003D81' strokeWidth='4' />
		<path d='M22.8574 39.5238L34.286 50.9524L56.6669 28.5714' stroke='#41B6E6' strokeWidth='4' />
	</svg>
);
